import { lazy, Suspense, useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setUser } from './redux/userReducer.js'
import { getMe } from './axios/function.js'

// Layout
const Authenticated = lazy(() => import('./Layout/MainLayout'))

const Test = lazy(() => import('./schemes/Test.jsx'))

// Screens (lazy loaded)
const Dashboard = lazy(() => import('./screens/Dashboard'))
const OfficerDashboardPage = lazy(() =>
  import('./screens/OfficerDashboardPage.jsx')
)
const OfficerApplicationsPage = lazy(() =>
  import('./screens/OfficerApplicationsPage.jsx')
)
const OfficerMSMEDirectoryPage = lazy(() =>
  import('./screens/OfficerMSMEDirectoryPage.jsx')
)

const UdyamPage = lazy(() => import('./screens/InProcess'))
const AddUdyamPage = lazy(() => import('./screens/AddUdyamPage'))
const AllUdyamPage = lazy(() => import('./screens/AllUdyamPage'))
const MyUdyamPage = lazy(() => import('./screens/MyUdyamPage'))

const UdyamInfo = lazy(() => import('./screens/UdyamInfo'))
const IndexPage = lazy(() => import('./screens/IndexPage'))
const IndexInfo = lazy(() => import('./screens/IndexInfo'))
const AssignmentPage = lazy(() => import('./screens/AssignmentPage'))

const VerifyPage = lazy(() => import('./screens/VerifyInnerPage.jsx'))
const Verify = lazy(() =>
  import('./screens/VerifyMainPage.jsx').then(m => ({ default: m.Verify }))
)

const Users = lazy(() => import('./screens/UserPage'))
const UserPage = lazy(() => import('./screens/UserPage'))
const Batches = lazy(() => import('./screens/BatchPage'))
const Performance = lazy(() => import('./screens/Performance'))

const EditProfile = lazy(() => import('./screens/ProfileEdit'))
const EditModel = lazy(() => import('./screens/EditModelPage'))

const ApprovedPage = lazy(() => import('./screens/ApprovedPage'))

const QueryTypePage = lazy(() => import('./screens/QueryTypePage'))
const Query = lazy(() => import('./screens/QueryPage'))

const AttendingForm = lazy(() => import('./screens/AttendingForm'))
const ExportData = lazy(() => import('./screens/ExportData'))

const EnterpriseProfile = lazy(() => import('./screens/EnterpriseProfile'))

const Training = lazy(() => import('./screens/Training.jsx'))
const Trainee = lazy(() => import('./screens/Trainee.jsx'))
const VideoTrainingPage = lazy(() => import('./screens/VideoTrainingPage.jsx'))
const TrainingFeedbackPage = lazy(() =>
  import('./screens/TrainingFeedbackPage.jsx')
)
const TraineeSignupPage = lazy(() => import('./screens/TraineeSignupPage.jsx'))

const UserDashboardPage = lazy(() => import('./screens/UserDashboardPage.jsx'))
const SchemeLockerPage = lazy(() => import('./screens/SchemeLockerPage.jsx'))
const ContentLibraryPage = lazy(() =>
  import('./screens/ContentLibraryPage.jsx')
)
const TasksRemindersPage = lazy(() =>
  import('./screens/TasksRemindersPage.jsx')
)
const DocumentsVaultPage = lazy(() =>
  import('./screens/DocumentsVaultPage.jsx')
)

const SchemeEligibilityPage = lazy(() =>
  import('./screens/SchemeEligibilityPage.jsx')
)
const MarketsAndSalesPage = lazy(() =>
  import('./screens/MarketsAndSalesPage.jsx')
)
const CapacityBuildingPage = lazy(() =>
  import('./screens/CapacityBuildingPage.jsx')
)
const ResourcesToolsPage = lazy(() =>
  import('./screens/ResourcesToolsPage.jsx')
)
const SupportHandholdingPage = lazy(() =>
  import('./screens/SupportHandholdingPage.jsx')
)

const CompanyProfilePage = lazy(() =>
  import('./screens/CompanyProfilePage.jsx')
)
const SchemeMonitoringPage = lazy(() =>
  import('./screens/SchemeMonitoringPage.jsx')
)
const TaskManagerPage = lazy(() => import('./screens/TaskManagerPage.jsx'))
const TrainingAttendanceMonitorPage = lazy(() =>
  import('./screens/TrainingAttendanceMonitorPage.jsx')
)
const AnnouncementsPage = lazy(() => import('./screens/AnnouncementsPage.jsx'))
const PresentationsAdminPage = lazy(() =>
  import('./screens/ResourceToolsAdminPage.jsx')
)
const UdyamVerifyStatusAdminPage = lazy(() =>
  import('./screens/UdyamVerifyStatusAdminPage.jsx')
)
const RustWasmDemoPage = lazy(() => import('./screens/RustWasmDemoPage.jsx'))
const AiQueryAdminPage = lazy(() => import('./screens/AiQueryAdminPage.jsx'))
const WebSocketTesterPage = lazy(() => import('./screens/WebSocketTesterPage.jsx'))

const UnitToMapPage = lazy(() => import('./screens/UnitToMapPage.jsx'))
const LocationPage = lazy(() => import('./screens/Location'))

const PrivacyPolicy = lazy(() => import('./screens/PrivacyPage'))
const Login = lazy(() => import('./screens/LoginPage'))
const DprRecipeLoginPage = lazy(() => import('./screens/DprRecipeLoginPage.jsx'))
const DprRecipeWizardPage = lazy(() => import('./screens/DprRecipeWizardPage.jsx'))
const Register = lazy(() => import('./screens/RegisterPage'))
const Landing = lazy(() => import('./screens/Landing'))

// Schemes
const Cgstmse = lazy(() => import('./schemes/CgstmsePage'))
const Cicss = lazy(() => import('./schemes/CicssPage'))
const GlobalMart = lazy(() => import('./schemes/GlobalMartPage'))
const Innovative = lazy(() => import('./schemes/InnovativePage'))
const Cdp = lazy(() => import('./schemes/MsmeCpdPage'))
const Pms = lazy(() => import('./schemes/PmsPage'))
const Pmegp = lazy(() => import('./schemes/PmegpPage'))
const Zed = lazy(() => import('./schemes/ZedPage'))
const Sfurti = lazy(() => import('./schemes/SfurtiPage'))

function App () {
  const dispatch = useDispatch()

  useEffect(() => {
    console.log('i am chec king')
    getMe()
      .then(res => dispatch(setUser(res)))
      .catch(err => {})
  }, [])

  return (
    <Suspense
      fallback={
        <div
          style={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f0f2f5',
            zIndex: 9999
          }}
        >
          {/* Logo */}
          <img
            src='/logo.webp'
            alt='MEMiz'
            style={{
              height: 48,
              width: 'auto',
              marginBottom: 28,
              opacity: 0.92
            }}
          />

          {/* Animated bar */}
          <div
            style={{
              width: 200,
              height: 3,
              borderRadius: 99,
              background: '#e5e7eb',
              overflow: 'hidden',
              marginBottom: 20
            }}
          >
            <div
              style={{
                height: '100%',
                width: '45%',
                borderRadius: 99,
                background: '#E01219',
                animation: 'memiz-slide 1.2s ease-in-out infinite'
              }}
            />
          </div>

          <p
            style={{
              margin: 0,
              fontSize: 12,
              fontWeight: 600,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#9ca3af'
            }}
          >
            Loading MEMiz…
          </p>

          <p
            style={{
              margin: '6px 0 0',
              fontSize: 11,
              color: '#d1d5db'
            }}
          >
            MSME Elevate Mizoram
          </p>

          <style>{`
          @keyframes memiz-slide {
            0%   { transform: translateX(-100%); }
            60%  { transform: translateX(320%); }
            100% { transform: translateX(320%); }
          }
        `}</style>
        </div>
      }
    >
      <Routes>
        <Route element={<Authenticated />}>
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/officer-dashboard' element={<OfficerDashboardPage />} />
          <Route
            path='/officer-applications'
            element={<OfficerApplicationsPage />}
          />
          <Route
            path='/officer-msme-directory'
            element={<OfficerMSMEDirectoryPage />}
          />

          <Route
            path='/location/:latitude/:longitude'
            element={<LocationPage />}
          />
          <Route path='/udyam' element={<UdyamPage />} />
          <Route path='/batches' element={<Batches />} />
          <Route path='/performance' element={<Performance />} />
          <Route path='/alludyam' element={<AllUdyamPage />} />
          <Route path='/approved' element={<IndexPage />} />
          {/* <Route path="/addudyam" element={<AddUdyamPage />} /> */}
          <Route path='/assignment' element={<AssignmentPage />} />

          <Route path='/info/:id' element={<UdyamInfo />} />
          <Route path='/index/:id' element={<IndexInfo />} />
          <Route path='/verify-vs/:id' element={<VerifyPage />} />

          <Route path='/users' element={<Users />} />

          <Route path='/editProfile' element={<EditProfile />} />
          {/* <Route path="/approvedPage" element={<ApprovedPage />} /> */}
          <Route path='/queryType' element={<QueryTypePage />} />
          <Route path='/query' element={<Query />} />
          <Route path='/user' element={<UserPage />} />

          <Route path='/editModel' element={<EditModel />} /> 

          <Route path='/myUdyam' element={<MyUdyamPage />} />
          <Route path='/verify' element={<Verify />} />
          <Route path='/verify/:id' element={<Verify />} />

          <Route path='/attendingForm' element={<AttendingForm />} />
          <Route path='/exportData' element={<ExportData />} />

          <Route path='/trainings' element={<Training />} />
          <Route path='/trainees' element={<Trainee />} />
          <Route path='/video-training' element={<VideoTrainingPage />} />
          <Route path='/content-library' element={<ContentLibraryPage />} />

          <Route path='/test' element={<Test />} />

          <Route
            path='/businessProfile/:user_id/:udyam_id'
            element={<EnterpriseProfile />}
          />
          {/* <Route path="/promoterProfile" element={<PromoterProfilePage />} /> */}

          <Route path='/userDashboard' element={<UserDashboardPage />} />
          <Route path='/company-profile' element={<CompanyProfilePage />} />
          <Route path='/scheme-monitoring' element={<SchemeMonitoringPage />} />
          <Route path='/task-manager' element={<TaskManagerPage />} />
          <Route
            path='/training-attendance'
            element={<TrainingAttendanceMonitorPage />}
          />
          <Route path='/announcements' element={<AnnouncementsPage />} />
          <Route path='/presentations' element={<PresentationsAdminPage />} />
          <Route path='/udyam-verify-status' element={<UdyamVerifyStatusAdminPage />} />
          <Route path='/rust-wasm-demo' element={<RustWasmDemoPage />} />
          <Route path='/ai-query' element={<AiQueryAdminPage />} />
          <Route path='/websocket-tester' element={<WebSocketTesterPage />} />
          <Route path='/schemeLocker' element={<SchemeLockerPage />} />
          <Route path='/tasks' element={<TasksRemindersPage />} />
          <Route path='/documentsVault' element={<DocumentsVaultPage />} />
        </Route>

        <Route path='/' element={<Landing />} />
        <Route path='/privacy' element={<PrivacyPolicy />} />

        <Route path='/cgstmse' element={<Cgstmse />} />
        <Route path='/cicss' element={<Cicss />} />
        <Route path='/global' element={<GlobalMart />} />
        <Route path='/innovative' element={<Innovative />} />
        <Route path='/cdp' element={<Cdp />} />
        <Route path='/pms' element={<Pms />} />
        <Route path='/pmegp' element={<Pmegp />} />
        <Route path='/zed' element={<Zed />} />
        <Route path='/sfurti' element={<Sfurti />} />

        <Route path='/scheme-finder' element={<SchemeEligibilityPage />} />
        <Route path='/markets-sales' element={<MarketsAndSalesPage />} />
        <Route path='/capacity-building' element={<CapacityBuildingPage />} />
        <Route path='/resources-tools' element={<ResourcesToolsPage />} />
        <Route
          path='/support-handholding'
          element={<SupportHandholdingPage />}
        />

        <Route path='/login' element={<Login />} />
        <Route path='/dpr_recipe' element={<DprRecipeLoginPage />} />
        <Route path='/dpr_recipe/setup' element={<DprRecipeWizardPage />} />
        <Route path='/register' element={<Register />} />
        <Route path='/feedback' element={<TrainingFeedbackPage />} />
        <Route path='/training-signup' element={<TraineeSignupPage />} />
      </Routes>
    </Suspense>
  )
}

export default App
